export default "__VITE_ASSET__CC83lugl__"